module.exports = __webpack_public_path__ + "img/VIENNA.415a8aad.png";